import * as types from './ActionTypes';
import {initialState} from './InitialState'

export default {
  initialState: initialState,
  types: types
}
